import React, { RefObject, useState } from 'react'
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import { ContentCopy, Settings } from '@mui/icons-material'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state'
import VacancyPopup from './VacancyPopup'
import { t } from 'i18next'
import { Dayjs } from 'dayjs'
import { Project } from '../../store/types'
import Demand from '../../store/types/models/Demand'

type VacancyMenuPopupProps = {
  month: Dayjs
  stateProjects: Project[]
  demandResponse: Demand[]
  isEditionDisabled: () => boolean
  vacancyRef: RefObject<HTMLButtonElement>
  addEmployeeRef: RefObject<HTMLButtonElement>
  firstProjectRef: RefObject<HTMLDivElement>
}

const VacancyMenuPopup: React.FC<VacancyMenuPopupProps> = ({
  month,
  stateProjects,
  demandResponse,
  isEditionDisabled,
  vacancyRef,
  addEmployeeRef,
  firstProjectRef,
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  return (
    <PopupState variant="popover" popupId="vacancy-menu-popup" disableAutoFocus={false} parentPopupState={null}>
      {popupState => (
        <>
          <IconButton
            tabIndex={-1}
            ref={vacancyRef}
            {...bindTrigger(popupState)}
            size="small"
            sx={{ padding: 0, marginLeft: 1 }}
            disabled={isEditionDisabled()}
            onKeyDown={event => {
              if (event.key === 'Tab') {
                event.preventDefault()
                if (!event.shiftKey) {
                  firstProjectRef.current?.focus()
                } else {
                  addEmployeeRef.current?.focus()
                }
              }
            }}
          >
            <Settings fontSize="small" />
          </IconButton>
          <Menu
            {...bindMenu(popupState)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem
              onClick={() => {
                setIsPopupOpen(true)
                popupState.close()
              }}
            >
              <ListItemIcon>
                <ContentCopy fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('components.vacancyPopup.manage')}</ListItemText>
            </MenuItem>
          </Menu>
          <VacancyPopup
            open={isPopupOpen}
            onClose={() => setIsPopupOpen(false)}
            month={month}
            stateProjects={stateProjects}
            demandResponse={demandResponse}
          />
        </>
      )}
    </PopupState>
  )
}

export default VacancyMenuPopup